

window.addEventListener('load', function () {
    (function(){



        var loadScript = function(url, callback){
            var script = document.createElement("script");
            script.type = "text/javascript";
            // If the browser is Internet Explorer.
            if (script.readyState){ 
                script.onreadystatechange = function(){
                    if (script.readyState == "loaded" || script.readyState == "complete"){
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            // For any other browser.
            } else {
                script.onload = function(){
                    callback();
                };
            }
            script.src = url;
            document.getElementsByTagName("head")[0].appendChild(script);    
        };
        
        
        // product quickview on collection page
        function onVariantSelect(container, productId, selector){    
                var productSelector = '#ProductSelect-'+productId,
                    optionsLength = $(selector).length;
                $(selector).prop("selectedIndex", 0);
                $(selector).on('change', function() {
                    onVariantChange(optionsLength, productId, productSelector, container);
                });
        }
        
        // product quickview on collection page -- on variant select from dropdown
        function onVariantChange(optionsLength, productId, productSelector, container){
            //console.log("onVariantChange "+productId);
            var selectedValue="", selectedVariant=""; 
            //console.log(optionsLength);
        
            //get selected value from all dropdown options
            for (ctr=0; ctr<optionsLength; ctr++) {
                selectedValue = selectedValue + $('#SingleOptionSelector-'+ productId +'-'+ctr).val(); 
                //console.log('#SingleOptionSelector-'+ productId +'-'+ctr);
                //console.log(selectedValue);
                if(ctr < optionsLength-1) {
                    selectedValue = selectedValue+"-";                    
                }
            }
            //console.log(productSelector);
            selectedVariant = $.trim(selectedValue.toLowerCase().replace(/\W+/g,'-'));  
            //console.log("SELECTED VARIANT: "+selectedVariant);
            var selectedVariantPrice;
            if (selectedVariant != "" || selectedVariant != null ) { 
        
                if($(productSelector+' option[data-title='+ selectedVariant +']').length){
                    // if variant is sold out or not available
                    if($(productSelector+' option[data-title='+ selectedVariant +']').is(':disabled')) {
                        $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
                        $('#AddToCartText-'+productId).text(theme.strings.soldOut); 
                        $('#AddToCart-'+productId).prop('disabled', true); 
                        $(productSelector).find('option:selected').prop('selected', false);  
                        
                         if($(container+' .regular-price').is(':visible')) {
                                $(container+' .regular-price').remove();   
                         }
                        selectedVariantPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('price');
                        $(container+' .product-single__price .price').text(selectedVariantPrice);
                    }
                    else {
                        $(productSelector).find('option:selected').prop('selected', false);
                        $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
                        $('#AddToCart-'+productId).prop('disabled', false);
                        $('#AddToCartText-'+productId).text(theme.strings.addToCart);
        
                        selectedVariantPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('price');
                        $(container+' .product-single__price .price').text(selectedVariantPrice);
                        if($(productSelector+' option[data-title='+ selectedVariant +']').hasClass('sale')){
                            $(container+' .regular-price').remove(); 
                            var selectedRegularPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('regularprice');
                            $(container+' .product-single__price').prepend('<s class="regular-price">'+ selectedRegularPrice+'</s>');
                        }
                        else {
                            if($(container+' .regular-price').is(':visible')) {
                                $(container+' .regular-price').remove();  
                            }
                        }
                    }
                    //From #ProductSelect, if selected variant's data-status is a Pre-order, update button text to Pre-Order
                    if($(productSelector+' option[data-title='+ selectedVariant +']').attr('data-status') == 'Pre-Order') {
                        $('.pre-order-input-property-'+productId).attr('name','properties[Pre-Order]');
                        $('.pre-order-input-property-'+productId).val("Yes"); 
                        $('#AddToCartText-'+productId).text("Pre-Order"); 
                    }
                    else {
                     $('.pre-order-input-property-'+productId).attr('name','');
                     $('.pre-order-input-property-'+productId).val("");  
                    }
                }
                else {
                    //console.log(productSelector+" ____ "+productId+"--- "+selectedVariant);
                    $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
                    $('#AddToCartText-'+productId).text(theme.strings.unavailable);
                    $('#AddToCart-'+productId).prop('disabled', true); 
                    $(productSelector).find('option:selected').prop('selected', false);   
                }
            }
            else {
                //console.log("NULL: "+productId);
                $('#AddToCartText-'+productId).text(theme.strings.unavailable);    
                $('#AddToCart-'+productId).prop('disabled', true);
                $(productSelector).find('option:selected').prop('selected', false);
            }
                    
        }
        
        
        var product_quickview = function($) { 
            $(".quick_view").fancybox({
                margin: 0, 
                animationEffect: "fade",
                transitionEffect: "slide",
                transitionDuration: 500,
                buttons:['close'],
                autoSize: false,
                afterShow: function(instance, current) {
                    if ($(current.src+' .selector-wrapper.color-selector select').length) {
                        $(current.src+' .selector-wrapper.color-selector select').each(function(){          
                            $(this).prop("selectedIndex", 0); 
                            var initVal = $(this).val();
                            $(this).val(initVal).trigger('change.fs'); 
                        });
                    }
                    var productId = $(current.src).data('product-id');
                    var selector = current.src+' .single-option-selector';
                    onVariantSelect(current.src, productId, selector);

                    $(".product-full-slider").slick("setPosition", 0);
                }
            });
        };
        
        
        
        /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
        we will load jQuery from the Google CDN, and when it's fully loaded, we will run
        our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
        as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
        if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
            loadScript('//cdnjs.cloudflare.com/ajax/libs/jquery/3.4.0/jquery.min.js', function(){
                jQuery191 = jQuery.noConflict(true);
             
                    product_quickview(jQuery191);
        
            });
        } else {  
            
                product_quickview(jQuery);  
            
        }
        
        })();
            
        
    });